module.exports = __webpack_public_path__ + "img/rebecca-on-huge-treehouse.b0f10bd0.jpg";